module.exports = __webpack_public_path__ + "img/logo-ALC-P.svg.090b8f20.svg";